/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './templates-front.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../../../app/front/templates-front/templates-front.component';
import * as i4 from '../../../../app/front/front.service';
const styles_TemplatesFrontComponent:any[] = [i0.styles];
export const RenderType_TemplatesFrontComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TemplatesFrontComponent,data:{}});
export function View_TemplatesFrontComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_TemplatesFrontComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-templates-front',
      ([] as any[]),(null as any),(null as any),(null as any),View_TemplatesFrontComponent_0,
      RenderType_TemplatesFrontComponent)),i1.ɵdid(1,114688,(null as any),0,i3.TemplatesFrontComponent,
      [i4.FrontService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TemplatesFrontComponentNgFactory:i1.ComponentFactory<i3.TemplatesFrontComponent> = i1.ɵccf('app-templates-front',
    i3.TemplatesFrontComponent,View_TemplatesFrontComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC90ZW1wbGF0ZXMtZnJvbnQvdGVtcGxhdGVzLWZyb250LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2h0bWwvTXlEZXNpZ25WMy9odG1sL3NyYy9hcHAvZnJvbnQvdGVtcGxhdGVzLWZyb250L3RlbXBsYXRlcy1mcm9udC5jb21wb25lbnQudHMiLCJuZzovLy92YXIvd3d3L2h0bWwvTXlEZXNpZ25WMy9odG1sL3NyYy9hcHAvZnJvbnQvdGVtcGxhdGVzLWZyb250L3RlbXBsYXRlcy1mcm9udC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC90ZW1wbGF0ZXMtZnJvbnQvdGVtcGxhdGVzLWZyb250LmNvbXBvbmVudC50cy5UZW1wbGF0ZXNGcm9udENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD4iLCI8YXBwLXRlbXBsYXRlcy1mcm9udD48L2FwcC10ZW1wbGF0ZXMtZnJvbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBOzBEQUFBO1VBQUE7SUFBQTs7OztvQkNBQTtNQUFBO3dDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/templates-front/templates-front.component.ngfactory.ts